import { Controller, useFormContext } from "react-hook-form";
import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import { FC } from "react";
import __ from "src/utils/Translations";

interface IConfigOptionProps {
  name: string;
  title: string;
  description?: string;
  disabled?: boolean;
  disabledByParent: boolean;
  parentAbsenceType: string | null;
  dataTestId?: string;
}

const ConfigOption: FC<IConfigOptionProps> = ({
  name,
  title,
  description = null,
  disabled = false,
  disabledByParent,
  parentAbsenceType,
  dataTestId,
}) => {
  const { control } = useFormContext();
  const disabledOption = disabled || (!!parentAbsenceType && disabledByParent);

  return (
    <Box
      sx={{
        bgcolor: "grey.100",
        padding: "1rem",
        marginBottom: "1rem",
        borderRadius: "0.5rem",
      }}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field: { value, onChange } }) => (
          <FormControlLabel
            control={
              <Switch
                checked={!!value}
                onChange={onChange}
                disabled={disabledOption}
                data-testid={dataTestId}
              />
            }
            label={title}
            slotProps={{
              typography: {
                variant: "subtitle1",
              },
            }}
          />
        )}
      />
      {description && (
        <Typography variant="body2" color="textSecondary">
          {__(description)}
        </Typography>
      )}
    </Box>
  );
};

export default ConfigOption;
